import { render, staticRenderFns } from "./DrawerItem.vue?vue&type=template&id=37d232d4&scoped=true&"
import script from "./DrawerItem.vue?vue&type=script&lang=js&"
export * from "./DrawerItem.vue?vue&type=script&lang=js&"
import style0 from "./DrawerItem.vue?vue&type=style&index=0&id=37d232d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d232d4",
  null
  
)

export default component.exports